import { gql } from '@apollo/client';

export const createNoteEntry = gql`
  mutation createNoteEntry(
    $entryTime: Int
    $entryText: String
    $controllerNotesId: String
  ) {
    createNoteEntry(
      entryTime: $entryTime
      entryText: $entryText
      controllerNotesId: $controllerNotesId
    ) {
      controllerNotesId
      createdAt
      createdBy
      deletedAt
      id
      note
      time
      updatedAt
      updater
      version
    }
  }
`;
